<script lang="ts">
  import { Button, Col, Form, FormGroup, Image, Input } from "sveltestrap";
  import { href, Submit } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/ecommerce"
</script>
<Form class="theme-form row">
    <Col xs="6" class="p-r-0">
      <FormGroup>
        <Input type="text" placeholder="First Name" />
      </FormGroup>
    </Col>
    <Col xs="6">
      <FormGroup>
        <Input type="text" placeholder="Last name" />
      </FormGroup>
    </Col>
    <Col xs="6" class="p-r-0">
      <FormGroup>
        <Input type="text" placeholder="Pincode" />
      </FormGroup>
    </Col>
    <Col xs="6">
      <FormGroup>
        <Input type="select" name="select" value="Bank Name">
          <option>{'Bank Name'}</option>
          <option>{'SBI'}</option>
          <option>{'ICICI'}</option>
          <option>{'KOTAK'}</option>
          <option>{'BOB'}</option>
        </Input>
      </FormGroup>
    </Col>
    <Col xs="12">
      <FormGroup>
        <Input type="select" name="select" value="Select Card">
          <option>{'Select Card'}</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
        </Input>
      </FormGroup>
    </Col>
    <Col xs="12">
      <FormGroup>
        <Input type="select" name="select" value="Select Duration">
          <option>{'Select Duration'}</option>
          <option>2015-2016</option>
          <option>2016-2017</option>
          <option>2017-2018</option>
          <option>2018-2019</option>
        </Input>
      </FormGroup>
    </Col>
    <Col xs="12">
      <FormGroup>
        <ul class="payment-opt">
          <li><Image src="{imgPath}/mastercard.png" /></li>
          <li><Image src="{imgPath}/visa.png" /></li>
          <li><Image src="{imgPath}/paypal.png" /></li>
        </ul>
      </FormGroup>
    </Col>
    <Col xs="12">
      <Button color="primary" class="btn-block" href={href}>{Submit}</Button>
    </Col>
</Form>